export const BLACKLIST_DEVICES_LIST = 'ROLE_BlacklistDevice_collection_get';
export const BLACKLIST_DEVICE_CREATE = 'ROLE_BlacklistDevice_collection_post';
export const BLACKLIST_DEVICE_SHOW = 'ROLE_BlacklistDevice_item_get';
export const BLACKLIST_DEVICE_EDIT = 'ROLE_BlacklistDevice_item_put';
export const BLACKLIST_DEVICE_DELETE = 'ROLE_BlacklistDevice_item_delete';